import React, { useMemo } from 'react';
import TransferList from '../TransferList';
import { reportField } from './reportFields';

const fieldLabel = (key) => reportField(key).label;
const fieldGroup = (key) => reportField(key).group;

/**
 * Picks a layout's fields. `selectedItems` (field keys, in report column order) is the only state;
 * the available fields are the rest of `items`, in catalog order, grouped and labelled from
 * reportFields.
 */
export default function LayoutDefinition({ items = [], selectedItems = [], onFieldListChange }) {
  const available = useMemo(() => items.filter((item) => !selectedItems.includes(item)), [items, selectedItems]);

  return (
    <div className="space-y-8">
      <TransferList
        availableItems={available}
        selectedItems={selectedItems}
        onSelectionChange={(selected) => onFieldListChange?.(selected)}
        availableTitle="Available Fields"
        selectedTitle="Selected Fields"
        getLabel={fieldLabel}
        getGroup={fieldGroup}
        searchable
        reorderable
      />
    </div>
  );
}
